import StorageConfiguration from './storageConfiguration';

export default StorageConfiguration;
